<template>
  <v-card
    class="ma-0 ps-0"
    :width="$store.state.isMenuExpanded ? 'calc(100% - 11px)' : 'calc(100% - 11px)'"
    style="border-radius: 4px;min-height: 111px !important;border: 1px solid #e3e3e3"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-4 py-1 px-4"
      dense
      height="36"
    >
      <v-toolbar-title> {{ $t('quickAccessToCustomer') }}</v-toolbar-title>
      <v-spacer />
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      lazy-validation
    >
      <v-container>
        <v-row>
          <v-col
            cols="12"
            md="12"
            class="mb-3  "
          >
            <search-customer
              v-model="customer"
              :show-dashboard="true"
              @go-dashboard="$emit('go-dashboard')"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-tabs
            height="40"
          >
            <v-tab
              v-for="(item, i) in components"
              :key="i"
              v-show="$store.state.permissions && $store.state.permissions.length > 0 && $store.state.permissions.includes(item.to)"
            >
              {{ $t(item.name) }}
            </v-tab>
            <v-tab-item
              v-for="(item, i) in components"
              :key="i"
              v-show="$store.state.permissions && $store.state.permissions.length > 0 && $store.state.permissions.includes(item.to)"
            >
              <v-container>
                <v-row>
                  <component
                    :is="item.component"
                    :id-prop="null"
                    :account-prop="customer"
                    :not-store="null"
                    :type-prop="item.type"
                  />
                </v-row>
              </v-container>
            </v-tab-item>
          </v-tabs>
        </v-row>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
  import searchCustomer from './personsSerach'
  import General from '../../../../Mixins/general'
  import invoiceList from '../invoice/list'
  import turnover from '../accounting/turnover'
  import task from '../task/list'
  export default {
    name: 'Product',
    components: {
      searchCustomer,
      invoiceList,
      task,
      turnover,
    },
    mixins: [General],
    props: ['formType'],
    data: () => ({
      render: true,
      customer: null,
      components: [
        {
          component: 'invoiceList',
          name: 'sell',
          to: 'sellList',
          type: 'sell',
        },
        {
          component: 'invoiceList',
          to: 'purchaseList',
          name: 'purchase',
          type: 'purchase',
        },
        {
          component: 'invoiceList',
          to: 'presaleList',
          name: 'presale',
          type: 'presale',
        },
        {
          component: 'turnover',
          to: 'turnover',
          name: 'turnover',
          type: 'turnover',
        },
        {
          component: 'task',
          to: 'TaskList',
          name: 'relatedTasks',
          type: 'related',
        },
        {
          component: 'task',
          to: 'TaskList',
          name: 'participantTasks',
          type: 'participants',
        },
      ],
    }),
    watch: {
      customer (val) {
      },
    },
    beforeMount () {
    },
    mounted () {
    },
    methods: {
    },
  }
</script>

<style scoped>

</style>
